import { render, staticRenderFns } from "./TicketCrm.vue?vue&type=template&id=5c3a785f&scoped=true&"
import script from "./TicketCrm.vue?vue&type=script&lang=ts&"
export * from "./TicketCrm.vue?vue&type=script&lang=ts&"
import style0 from "./TicketCrm.vue?vue&type=style&index=0&id=5c3a785f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3a785f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c3a785f')) {
      api.createRecord('5c3a785f', component.options)
    } else {
      api.reload('5c3a785f', component.options)
    }
    module.hot.accept("./TicketCrm.vue?vue&type=template&id=5c3a785f&scoped=true&", function () {
      api.rerender('5c3a785f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ticket/TicketCrm.vue"
export default component.exports